"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ArrowUp = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowUp16"));
var _ArrowDown = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowDown16"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _lodash = require("lodash");
var HBNewTableExpandedIndicator = function HBNewTableExpandedIndicator(_ref) {
  var isRowExpanded = _ref.isRowExpanded,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    className: className,
    buttonTheme: "subtle-invisible",
    icon: isRowExpanded ? _ArrowUp["default"] : _ArrowDown["default"],
    label: isRowExpanded ? 'Collapse' : 'Expand',
    testIdName: 'row-expanded-indicator',
    onClick: _lodash.noop
  });
};
var _default = exports["default"] = HBNewTableExpandedIndicator;
//# sourceMappingURL=HBNewTableExpandedIndicator.js.map